import { render, staticRenderFns } from "./ContentLabel.vue?vue&type=template&id=549469f6&scoped=true"
import script from "./ContentLabel.vue?vue&type=script&lang=js"
export * from "./ContentLabel.vue?vue&type=script&lang=js"
import style0 from "./ContentLabel.vue?vue&type=style&index=0&id=549469f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "549469f6",
  null
  
)

export default component.exports